export default __webpack_public_path__ + "static/media/Attention-cropped.40ddb83d.svg";